import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  width?: string;
  height?: string;
}

export function Skeleton({ className, width, height, style, ...rest }: SkeletonProps) {
  return (
    <span
      className={clsx('vania-skeleton', className)}
      style={{ ...style, ...(width ? { width } : {}), ...(height ? { height } : {}) }}
      aria-hidden="true"
      {...rest}
    />
  );
}
